import _defineProperty from "@babel/runtime/helpers/defineProperty";
import cx from 'classnames';
import { Modifier, EditorState, ContentState, convertFromRaw } from 'draft-js';
import { Map } from 'immutable';
import _isNil from 'lodash/isNil';
import _isEmpty from 'lodash/isEmpty';
import _isString from 'lodash/isString';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { ALIGNMENTS, BLOCK_STYLE_PREFIX, BLOCK_STYLE_TYPES } from '../styles.contants';
import s from '../richTextEditor.module.scss';
export var getLinkFromState = function getLinkFromState(editorState) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var data = EMPTY_OBJECT;
  if (!selection.isCollapsed()) {
    var startKey = editorState.getSelection().getStartKey();
    var startOffset = editorState.getSelection().getStartOffset();
    var blockWithLinkAtBeginning = content.getBlockForKey(startKey);
    var linkKey = blockWithLinkAtBeginning.getEntityAt(startOffset);
    if (linkKey) {
      var linkInstance = content.getEntity(linkKey);
      data = linkInstance.getData();
    }
  }
  var _data = data,
    url = _data.url;
  return url;
};
export var clearFormatting = function clearFormatting(editorState) {
  var selection = editorState.getSelection();
  if (!selection.isCollapsed()) {
    var contentState = editorState.getCurrentContent();
    var styles = editorState.getCurrentInlineStyle();
    var removeStyles = styles.reduce(function (state, style) {
      return Modifier.removeInlineStyle(state, selection, style);
    }, contentState);
    var removeBlock = Modifier.setBlockType(removeStyles, selection, 'unstyled');
    return EditorState.push(editorState, removeBlock);
  }
  return editorState;
};
export var styleWholeSelectedBlocksModifier = function styleWholeSelectedBlocksModifier(editorState, style) {
  var removeStyles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var currentContent = editorState.getCurrentContent();
  var selection = editorState.getSelection();
  var focusBlock = currentContent.getBlockForKey(selection.getFocusKey());
  var anchorBlock = currentContent.getBlockForKey(selection.getAnchorKey());
  var selectionIsBackward = selection.getIsBackward();
  var changes = {
    anchorOffset: 0,
    focusOffset: focusBlock.getLength()
  };
  if (selectionIsBackward) {
    changes = {
      focusOffset: 0,
      anchorOffset: anchorBlock.getLength()
    };
  }
  var selectWholeBlocks = selection.merge(changes);
  var modifiedContent = Modifier.applyInlineStyle(currentContent, selectWholeBlocks, style);
  var finalContent = removeStyles.reduce(function (content, st) {
    return Modifier.removeInlineStyle(content, selectWholeBlocks, st);
  }, modifiedContent);
  return EditorState.push(editorState, finalContent, 'change-inline-style');
};
export var addBlockDataForSelection = function addBlockDataForSelection(editorState) {
  return function (type, value) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();
    var blockData = new Map(_defineProperty({}, type, value));
    var newContentState = Modifier.mergeBlockData(contentState, selectionState, blockData);
    return EditorState.push(editorState, newContentState, 'merge-block-data');
  };
};
export var getBlockDataValueForSelection = function getBlockDataValueForSelection(editorState) {
  return function (key) {
    var selection = editorState.getSelection();
    var block = editorState.getCurrentContent().getBlockForKey(selection.getFocusKey());
    return block.getData().get(key);
  };
};
export var blockStyleFn = function blockStyleFn(contentBlock) {
  var _cx;
  var blockData = contentBlock.getData();
  var lineHeight = blockData.get("".concat(BLOCK_STYLE_PREFIX).concat(BLOCK_STYLE_TYPES.LINE_HEIGHT));
  var textAlignment = blockData.get("".concat(BLOCK_STYLE_PREFIX).concat(BLOCK_STYLE_TYPES.TEXT_ALIGNMENT)) || ALIGNMENTS.LEFT;
  return cx((_cx = {}, _defineProperty(_cx, s["lineHeight-".concat(lineHeight)], !_isNil(lineHeight)), _defineProperty(_cx, s["align-".concat(textAlignment)], !_isNil(textAlignment)), _cx));
};
export var getEditorStateFromRawContent = function getEditorStateFromRawContent(rawContent) {
  switch (true) {
    case _isEmpty(rawContent):
      return EditorState.createEmpty();
    case _isString(rawContent):
      try {
        return getEditorStateFromRawContent(JSON.parse(rawContent));
      } catch (e) {
        return EMPTY_OBJECT;
      }
    case rawContent instanceof EditorState:
      return rawContent;
    case rawContent instanceof ContentState:
      return EditorState.createWithContent(rawContent);
    default:
      try {
        return EditorState.createWithContent(convertFromRaw(rawContent));
      } catch (e) {
        return EditorState.createEmpty();
      }
  }
};